export const LAMBDATEST_HYPERTEST_TASK_DETAIL_LOADING =
  "LAMBDATEST_HYPERTEST_TASK_DETAIL_LOADING";
export const LAMBDATEST_HYPERTEST_TASK_DETAIL_SUCCESS =
  "LAMBDATEST_HYPERTEST_TASK_DETAIL_SUCCESS";
export const LAMBDATEST_HYPERTEST_TASK_DETAIL_FAILED =
  "LAMBDATEST_HYPERTEST_TASK_DETAIL_FAILED";

export const LAMBDATEST_SET_VIDEO_START_TIMESTAMP =
  "LAMBDATEST_SET_VIDEO_START_TIMESTAMP";
